import { MiningMinigame, ORE_TIMEOUT } from '@phaser/minigames/mining';
import { DEPTH } from '@phaser/data/depth';
import { Game } from '@phaser/scenes/Game';
import * as Shared from '@shared/lib';

export class Ore {
  public spawnedAt: number;
  public strength: number;
  public keyId: number;
  public key: string;
  public id: string;
  public x: number;
  public y: number;

  private _mining: MiningMinigame;
  private _scene = Game.current;

  private _container: Phaser.GameObjects.Container;
  private _oreInner: Phaser.GameObjects.Arc;

  constructor(
    mining: MiningMinigame,
    id: string,
    ore: Shared.OreData,
    x: number,
    y: number
  ) {
    this.strength = ore.strength;
    this.spawnedAt = Date.now();
    this.keyId = ore.id;
    this.key = ore.key;
    this.id = id;
    this.x = x;
    this.y = y;

    this._mining = mining;

    this._spawnIn(x, y);
    this._startDespawn();
  }

  public destroy() {
    this._mining.stopMine(this.id);
    this._container.destroy();
  }

  private _spawnIn(x: number, y: number) {
    this._container = this._scene.add.container(x, y)
      .setDepth(DEPTH.MINIGAME);

    const ore = this._container.scene.add.circle(0, 0, 28, 0xFFFFFF, 0.3)
      .setOrigin(0.5)
      .setInteractive();
    this._container.add(ore);

    this._oreInner = this._container.scene.add.circle(0, 0, 28, 0xFFFFFF, 0.4)
      .setOrigin(0.5);
    this._container.add(this._oreInner);

    const laser = this._scene.add.image(0, 0, 'sprites', 'laser');
    this._container.add(laser);

    ore.on('pointerdown', () => {
      this._mining.mine(this.id);
    });

    this._scene.tweens.add({
      targets: [ore, this._oreInner],
      scale: { from: 0, to: 1 },
      duration: 300,
      ease: 'Power2',
    });
  }

  private _startDespawn() {
    const duration = ORE_TIMEOUT * this._mining.difficulty;

    this._scene.time.delayedCall(duration, () => {
      this.destroy();
    });

    this._scene.tweens.add({
      targets: this._oreInner,
      scale: { from: 1, to: 0 },
      duration,
    });
  }
}